// Navigation.js
import React, { useState, useEffect } from 'react';
import logo from '../Assets/logo.png';

const Navigation = ({ setCurrentPage, currentPage, language, setLanguage }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const translations = {
    en: {
      home: 'HOME',
      blocks: 'BLOCKS',
      slabs: 'SLABS',
      contact: 'CONTACT US',
      about: 'ABOUT US',
      exhibitions: 'EXHIBITIONS',
      projects: 'PROJECTS'
    },
    zh: {
      home: '首页',
      blocks: '块材',
      slabs: '板材',
      contact: '联系我们',
      about: '关于我们',
      exhibitions: '展览',
      projects: '项目'
    },
    it: {
      home: 'HOME',
      blocks: 'BLOCCHI',
      slabs: 'LASTRE',
      contact: 'CONTATTACI',
      about: 'CHI SIAMO',
      exhibitions: 'ESPOSIZIONI',
      projects: 'PROGETTI'
    }
  };

  const t = translations[language];

  return (
    <nav className={`navigation ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <div className="nav-logo" onClick={() => setCurrentPage('home')}>
          {/* Replace src with your actual logo path */}
          <img src={logo} alt="PA Global Collab" />
          {/* Fallback if logo doesn't load */}
          {/* <span className="logo-text">PA GLOBAL COLLAB</span> */}
        </div>

        <button 
          className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`nav-menu ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <li>
            <button 
              className={`nav-link ${currentPage === 'home' ? 'active' : ''}`}
              onClick={() => {
                setCurrentPage('home');
                setIsMobileMenuOpen(false);
              }}
            >
              {t.home}
            </button>
          </li>
          <li>
            <button 
              className={`nav-link ${currentPage === 'blocks' ? 'active' : ''}`}
              onClick={() => {
                setCurrentPage('blocks');
                setIsMobileMenuOpen(false);
              }}
            >
              {t.blocks}
            </button>
          </li>
          <li>
            <button 
              className={`nav-link ${currentPage === 'slabs' ? 'active' : ''}`}
              onClick={() => {
                setCurrentPage('slabs');
                setIsMobileMenuOpen(false);
              }}
            >
              {t.slabs}
            </button>
          </li>
          <li>
            <button 
              className={`nav-link ${currentPage === 'contact' ? 'active' : ''}`}
              onClick={() => {
                setCurrentPage('contact');
                setIsMobileMenuOpen(false);
              }}
            >
              {t.contact}
            </button>
          </li>
          <li>
            <button 
              className={`nav-link ${currentPage === 'about' ? 'active' : ''}`}
              onClick={() => {
                setCurrentPage('about');
                setIsMobileMenuOpen(false);
              }}
            >
              {t.about}
            </button>
          </li>
          <li>
            <button 
              className={`nav-link ${currentPage === 'exhibitions' ? 'active' : ''}`}
              onClick={() => {
                setCurrentPage('exhibitions');
                setIsMobileMenuOpen(false);
              }}
            >
              {t.exhibitions}
            </button>
          </li>
          <li>
            <button 
              className={`nav-link ${currentPage === 'projects' ? 'active' : ''}`}
              onClick={() => {
                setCurrentPage('projects');
                setIsMobileMenuOpen(false);
              }}
            >
              {t.projects}
            </button>
          </li>
          <li className="language-selector">
            <select 
              value={language} 
              onChange={(e) => setLanguage(e.target.value)}
              className="lang-select"
            >
              <option value="en">EN</option>
              <option value="zh">中文</option>
              <option value="it">IT</option>
            </select>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;